import React, { useState } from 'react';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Spinner,
    Alert,
    Row,
    Col,
    FormFeedback
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createUser } from './redux/dispatcher';
import { fetchCompanyList } from 'components/companyList/redux/dispatcher';
import toast from 'react-hot-toast';
import { useEffect } from 'react';

function AddUser({ args }) {
    const dispatch = useDispatch();
    const userList = useSelector((state) => state.userListReducer);
    const [loginUserType] = useState(useSelector((state) => state.authReducer).data?.user?.role)
    const companyListData = useSelector((state) => state.companyListReducer?.data?.data) || [];
    const [modal, setModal] = useState(false);
    const [status, setStatus] = useState(true);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mobile, setMobile] = useState('');
    const [loading, setLoading] = useState(userList?.isLoading);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const [roleType, setRoleType] = useState('')
    const [confrimPassword, setConfrimPassword] = useState('')
    const [selectedCompany, setSelectedCompany] = useState('')
    // const [isLoader, setIsLoader] = useState(true);
    const [formError, setFormError] = useState({
        firstName: false,
        lastName: false,
        email: false,
        mobile: false,
        password: false,
        confirmpassword: false,
        roleType: false,
    })

    useEffect(() => {
        if (modal && roleType === 'fluid_handler') {
            dispatch(fetchCompanyList());
        }
    }, [dispatch, modal, roleType]);


    const toggleModal = () => {
        setModal(!modal);
        setError('');
        setLoading(false);
        setFirstName('');
        setLastName('')
        setEmail('')
        setMobile('')
        setRoleType('')
        setPassword('')
        setConfrimPassword('')
        setSelectedCompany('')
        setErrorMessage('')
        setFormError({
            firstName: false,
            lastName: false,
            email: false,
            mobile: false,
            password: false,
            confirmpassword: false,
            roleType: false,
        })
    };

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const toggleCinfirmPasswordVisibility = () => {
        setIsConfirmPasswordVisible(!isConfirmPasswordVisible)
    }

    const handleStatusChange = () => setStatus(!status);


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        // Check if required fields are empty
        if (!firstName || !lastName || !email || !password || !confrimPassword || !roleType || (mobile.length > 0 && mobile.length < 10)) {
            setFormError({
                firstName: formError.firstName || !firstName,
                lastName: formError.lastName || !lastName,
                email: formError.email || !email,
                password: formError.password || !password,
                confirmpassword: formError.confirmpassword || !confrimPassword,
                mobile: formError.mobile,
                roleType: !roleType ? true : false,
            });
            setErrorMessage('Please correct the errors in the form.');
            setLoading(false);
            return;
        }

        // Check if passwords match
        if (password !== confrimPassword) {
            toast.error('Passwords do not match')
            setErrorMessage('Passwords do not match.');
            setLoading(false);
            return;
        }

        // Reset error messages
        setErrorMessage('');
        setError('');
        try {
            const userData = {
                first_name: firstName,
                last_name: lastName,
                email_id: email,
                password: password,
                role: roleType,
                status: status ? 'active' : 'inactive',
                ...(mobile && { mobile_number: mobile }),
                ...(roleType === 'fluid_handler' && selectedCompany && { company_id: selectedCompany })
            };

            // Now you can send userData

            dispatch(createUser(userData, toggleModal))
        } catch (err) {
            setErrorMessage('Error adding user. Please try again.')
            // setError('Error adding user. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    //Regex for validation 
    const validateFirstName = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, firstName: false }));
            return;
        }
        const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]{2,25}$/;


        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, firstName: !isValid }));
    };

    const validateLastName = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, lastName: false }));
            return;
        }
        const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]{2,25}$/;
        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, lastName: !isValid }));
    };

    const validateEmail = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, email: false }));
            return;
        }
        const regex = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;
        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, email: !isValid }));
    };

    const validateMobile = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, mobile: false }));
            return;
        }
        const regex = /^[0-9]{10}$/;
        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, mobile: !isValid }));
    };

    const validatePassword = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, password: false }));
            return;
        }
        const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/;
        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, password: !isValid }));
    };

    const validateConfirmPassword = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, confirmpassword: false }));
            return;
        }
        const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/;
        const isValid = regex.test(value);

        setFormError(prevState => ({ ...prevState, confirmpassword: !isValid }));
    };

    // if(isLoader){
    //     return <Loader />
    // }

    return (
        <div>
            <Button color="primary" onClick={toggleModal}>Add User
            </Button>

            <Modal isOpen={modal} toggle={toggleModal} {...args} modalClassName="custom-modal">
                <h1 style={{ textAlign: 'center', borderBottom: '4px solid #135674', color: '#135674' }} className="  m-3">
                    Add User
                </h1>
                <ModalBody>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="firstName">First Name<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="firstName"
                                        name="firstName"
                                        placeholder="Enter First Name"
                                        type="text"
                                        value={firstName}
                                        invalid={formError.firstName}
                                        onChange={(e) => {
                                            setFirstName(e.target.value)
                                            validateFirstName(e)
                                        }}
                                        maxLength={25}
                                    />
                                    <FormFeedback>First Name must only contain alphabets.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="lastName">Last Name<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="lastName"
                                        name="lastName"
                                        placeholder="Enter Last Name"
                                        type="text"
                                        value={lastName}
                                        invalid={formError.lastName}
                                        onChange={(e) => {
                                            setLastName(e.target.value)
                                            validateLastName(e)
                                        }}
                                        maxLength={25}
                                    />
                                    <FormFeedback>Last Name must only contain alphabets.</FormFeedback>
                                </FormGroup>

                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="email">Email<span style={{ color: 'red' }}>*</span> (User ID)</Label>
                                    <Input
                                        id="email"
                                        name="email"
                                        placeholder="Enter Email Id"
                                        type="email"
                                        value={email}
                                        invalid={formError.email}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            setEmail(e.target.value)
                                            validateEmail(e)
                                        }}
                                    />
                                    <FormFeedback>Email must be a valid email address.</FormFeedback>
                                </FormGroup>

                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="mobile">Mobile</Label>
                                    <Input
                                        id="mobile"
                                        name="mobile"
                                        placeholder="Enter Mobile"
                                        type="text"
                                        value={mobile}
                                        invalid={formError.mobile}
                                        onChange={(e) => {
                                            setMobile(e.target.value)
                                            validateMobile(e)
                                        }}
                                        maxLength={10}
                                    />
                                    <FormFeedback>Mobile Number must be exactly 10 digits and contain only numbers.</FormFeedback>

                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="roletype">Select Role<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="select"
                                        name="selectRole"
                                        id="roletype"
                                        // value={!isSuperAdmin ? 'fluidhandler' : roleType}
                                        // disabled={!isSuperAdmin}
                                        value={roleType}
                                        onChange={(e) => {
                                            setRoleType(e.target.value)
                                            setSelectedCompany('')
                                            setFormError(prevState => ({ ...prevState, roleType: false, company_id: false }));
                                        }}
                                        invalid={formError.roleType}
                                    >
                                        <option value="">Select Role</option>
                                        {/* <option value="company_admin">Company Admin</option>
                                        <option value="enterprise_admin">Enterprise Admin</option>
                                        <option value="fluid_handler">Fluid Handler</option> */}

                                        {loginUserType === 'super_admin' && (
                                            <>
                                                <option value="enterprise_admin">Enterprise Admin</option>
                                                <option value="company_admin">Company Admin</option>
                                                <option value="fluid_handler">Fluid Handler</option>
                                            </>
                                        )}
                                        {loginUserType === 'enterprise_admin' && (
                                            <>
                                                <option value="company_admin">Company Admin</option>
                                                <option value="fluid_handler">Fluid Handler</option>
                                            </>
                                        )}
                                        {loginUserType === 'company_admin' && (
                                            <>
                                                <option value="fluid_handler">Fluid Handler</option>
                                            </>
                                        )}
                                    </Input>
                                    <FormFeedback>Please select role type.</FormFeedback>
                                </FormGroup>
                            </Col>
                            {roleType === 'fluid_handler' && (
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="companySelect">Select Company (Optional)</Label>
                                        <Input
                                            type="select"
                                            name="selectCompany"
                                            id="companySelect"
                                            value={selectedCompany}
                                            onChange={(e) => {
                                                setSelectedCompany(e.target.value)
                                                setFormError(prevState => ({ ...prevState, company_id: false }));
                                            }}
                                        >
                                            <option value="">Select Company</option>
                                            {companyListData.map((company) => (
                                                <option key={company?.id} value={company?.id}>
                                                    {company?.company_name}
                                                </option>
                                            ))}
                                        </Input>

                                    </FormGroup>
                                </Col>
                            )}
                        </Row>

                        {/* <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Select Company*</Label>
                                    <Input
                                        type="text"
                                        id="searchInput"
                                        value={searchData}
                                        onChange={handleCompanySearch}
                                        placeholder="Search machine by thier name..."
                                    />
                                    <div style={{ maxHeight: '125px', overflowY: 'auto', border: '1px solid #ced4da', padding: '10px' }} className='rounded '>

                                        {filteredCompanyList.map((item, id) => (
                                            <CustomInput
                                                key={id}
                                                type="checkbox"
                                                id={`machine-${id}`}
                                                label={item}
                                                value={item}
                                                checked={selectedCompany.includes(item)}
                                                onChange={handleCompanySelection}
                                                className='m-1'
                                            />
                                        ))}
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row> */}

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="password">Password<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="password"
                                        name="password"
                                        placeholder="Enter Password"
                                        type={isPasswordVisible ? "text" : "password"}
                                        value={password}
                                        invalid={formError.password}
                                        onChange={(e) => {
                                            setPassword(e.target.value)
                                            validatePassword(e)
                                        }}
                                    />
                                    <FormFeedback>Password must be at least 8 characters long, contain at least one number and one special character.</FormFeedback>
                                    <i
                                        className={`fa fa-eye${isPasswordVisible ? '' : '-slash'} mr-3 mt-1`}
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            top: formError.password ? '35%' : '52%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer'
                                        }}
                                        onClick={togglePasswordVisibility}
                                    />

                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="confrimpassword">Confirm Password<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="confrimpassword"
                                        name="confrimpassword"
                                        placeholder="Enter Confirm Password"
                                        type={isConfirmPasswordVisible ? "text" : "password"}
                                        value={confrimPassword}
                                        // invalid={formError.confirmpassword}
                                        onChange={(e) => {
                                            setConfrimPassword(e.target.value)
                                            validateConfirmPassword(e)
                                        }}
                                    />
                                    {/* <FormFeedback>Confirm Password must be at least 8 characters long, contain at least one number and one special character.</FormFeedback> */}
                                    <i
                                        className={`fa fa-eye${isConfirmPasswordVisible ? '' : '-slash'} mr-3 mt-1`}
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            top: formError.password ? '35%' : '52%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer'
                                        }}
                                        onClick={toggleCinfirmPasswordVisibility}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <Label for="statusSelect">Status</Label>
                            <CustomInput
                                type="switch"
                                id="statusSelect"
                                name="status"
                                label={status ? 'Active' : 'Inactive'}
                                checked={status}
                                onChange={handleStatusChange}
                            />
                        </FormGroup>

                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleFormSubmit} disabled={loading}>
                        {loading ? <Spinner size="sm" className='mr-5 ml-5' /> : 'Add User'}
                    </Button>

                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default AddUser;
